module.exports = __webpack_public_path__ + "static/media/logo.526cd147.png";